import service from "@/store/services/repairs-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  repair: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, repair) => {
    state.repair = repair;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);

      return { list, meta };
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((repair) => {
      commit("SET_RESOURCE", repair);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((repair) => {
      commit("SET_RESOURCE", repair);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((repair) => {
      commit("SET_RESOURCE", repair);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  complete({ commit, dispatch }, { repairId, data = {} }) {
    return service.complete(repairId, data, this.$axios).then((request) => {});
  },

  cancel({ commit, dispatch }, params) {
    return service.cancel(params, this.$axios).then((request) => {});
  },

  getReport({ commit, dispatch }, params) {
    return service.getReport(params, this.$axios);
  },

  assign({ commit, dispatch }, { repairId, data }) {
    return service.assign(repairId, data, this.$axios).then((request) => {
      commit("SET_RESOURCE", request);
    });
  },

  validate({ commit, dispatch }, { repairId, data }) {
    return service.validate(repairId, data, this.$axios).then((repair) => {
      commit("SET_RESOURCE", repair);
    });
  },

  start({ commit, dispatch }, { repairId, data = {} }) {
    return service.start(repairId, data, this.$axios);
  },

  takeOver({ commit, dispatch }, { repairId, data = {} }) {
    return service.takeOver(repairId, data, this.$axios);
  },

  getReport({ commit, dispatch }, params) {
    return service.getReport(params, this.$axios);
  },

  redo({ commit, dispatch }, params) {
    return service.redo(params, this.$axios).then((request) => {
      commit("SET_RESOURCE", request);
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  repair: (state) => state.repair,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((repair) => ({
      id: repair.id,
      code: repair.code,
    }));
  },
};

const repairs = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default repairs;
